import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageSquare } from "lucide-react";
import { formatRelativeTime } from "./utils";

interface MessagesWidgetProps {
  messages: any[];
}

const MessagesWidget: React.FC<MessagesWidgetProps> = ({ messages }) => {
  const navigate = useNavigate();

  return (
    <motion.section
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
    >
      <div className="flex items-center gap-2 mb-4">
        <MessageSquare
          className="h-5 w-5 text-slate-700"
          aria-hidden="true"
        />
        <h2 className="text-lg font-bold" style={{ color: "#1F2937" }}>
          Messages
        </h2>
      </div>

      {!messages || messages.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <div className="h-12 w-12 rounded-full bg-slate-50 flex items-center justify-center mb-3">
            <MessageSquare className="h-6 w-6 text-slate-300" />
          </div>
          <p className="font-medium text-slate-500 text-sm">
            No unread messages
          </p>
          <p className="text-xs text-slate-400">
            All caught up on communications
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {messages.map((message: any) => (
            <div
              key={message._id}
              className="p-3 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
              onClick={() => navigate("/communications")}
            >
              <div className="flex items-start justify-between gap-2 mb-1">
                <p
                  className="font-medium text-sm"
                  style={{ color: "#1F2937" }}
                >
                  {message.clientId?.displayName ||
                    message.participants?.find(
                      (p: any) => p.kind === "contact"
                    )?.displayName ||
                    message.participants?.[0]?.displayName ||
                    "Unknown"}
                </p>
              </div>

              <p className="text-xs text-slate-600 mb-2">
                {message.matterId?.title || ""}
              </p>

              <div className="flex items-center justify-between text-xs">
                <span className="text-slate-500">
                  {formatRelativeTime(message.lastMessageAt)}
                </span>

                {(message.counts?.unreadMessages > 0 ||
                  message.counts?.missedCalls > 0) && (
                  <span
                    className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-white font-bold rounded-full"
                    style={{ backgroundColor: "var(--color-accent)" }}
                  >
                    {(message.counts?.unreadMessages || 0) +
                      (message.counts?.missedCalls || 0)}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </motion.section>
  );
};

export default MessagesWidget;
